<div class="my-7">
  <mat-form-field class="moneytor-input" [ngClass]="class">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      [name]="placeholder ? placeholder : label"
      [placeholder]="placeholder"
      [required]="required"
      [(ngModel)]="model"
      [disabled]="disabled"
      (ngModelChange)="onModelChange($event)"
      [matDatepicker]="name"
      #dateInput="ngModel"
      (click)="name.open()"
      />
    <mat-datepicker-toggle matSuffix [for]="name"></mat-datepicker-toggle>
    <mat-datepicker #name></mat-datepicker>
  </mat-form-field>
  <!-- <div *ngIf="dateInput.invalid && dateInput.touched">
  <mat-error *ngIf="dateInput.hasError('required')">This field is required*</mat-error>
</div> -->
</div>
